import { AppState, Auth0Provider } from "@auth0/auth0-react";
import React, { FC } from "react";
import { getVariableFromEnv } from "../../../common/utilities/env";
import useNavigateWithState from "../../../common/navigate/hooks/useNavigateWithState";
type Props = {
  children: React.ReactNode;
};
const Auth0ProviderWithRedirect: FC<Props> = ({ children }) => {
  const { navigateWithState } = useNavigateWithState();
  const onRedirectCallback = (appState?: AppState) => {
    navigateWithState(appState?.returnTo || window.location.pathname);
  };
  return (
    <Auth0Provider
      domain={getVariableFromEnv("AUTH_DOMAIN")}
      clientId={getVariableFromEnv("AUTH_CLIENT_ID")}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: getVariableFromEnv("AUTH_AUDIENCE"),
      }}
      // The SDK default is 60 s. A silent authorize that a broken iframe never
      // answers blocks every screen that waits on `isTokenRefreshing` for that
      // whole time.
      authorizeTimeoutInSeconds={15}
      useRefreshTokens
      useRefreshTokensFallback
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
export default Auth0ProviderWithRedirect;
